import { Spinner } from '@/components/ui';

/** Reusable list pager: "from–to of total" + Prev/Next. Offset-based to match
 *  the admin-svc list endpoints (limit/offset). */
export function Pager({
  total,
  offset,
  pageSize,
  onOffset,
  fetching,
}: {
  total: number;
  offset: number;
  pageSize: number;
  onOffset: (n: number) => void;
  fetching?: boolean;
}) {
  const from = total === 0 ? 0 : offset + 1;
  const to = Math.min(offset + pageSize, total);
  const canPrev = offset > 0;
  const canNext = offset + pageSize < total;
  return (
    <div className="flex items-center justify-between gap-3 border-t border-ink-700 px-3.5 py-2.5">
      <div className="flex items-center gap-2 text-xs text-text-secondary">
        <span>
          {from}–{to} of {total}
        </span>
        {fetching ? <Spinner /> : null}
      </div>
      <div className="flex items-center gap-2">
        <button
          type="button"
          disabled={!canPrev}
          onClick={() => onOffset(Math.max(0, offset - pageSize))}
          className="rounded-md border border-ink-700 bg-ink-900 px-2.5 py-1 text-xs font-medium text-slate-200 transition-colors hover:bg-hover disabled:opacity-40"
        >
          Prev
        </button>
        <button
          type="button"
          disabled={!canNext}
          onClick={() => onOffset(offset + pageSize)}
          className="rounded-md border border-ink-700 bg-ink-900 px-2.5 py-1 text-xs font-medium text-slate-200 transition-colors hover:bg-hover disabled:opacity-40"
        >
          Next
        </button>
      </div>
    </div>
  );
}
